import React from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Button, Card, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import './styles.less';
import { AppName, authBackgroundImg } from '@/config';
import LanguageSelector from '@/components/app/LanguageSelector';
import { apiSdk } from '@/httpClient';
import { PublicRoutes } from '@/routers/publicRoutes';

export const authLogo = require('@/assets/logos/applogo.png');

/**
 * Lien de l'e-mail de confirmation d'adresse (API : AppSettings:ClientConfirmEmailUrl?userId=…&code=…). Le code est
 * renvoyé tel quel à users/confirm-email ; la page n'affiche que le résultat.
 */
const ConfirmEmail = () => {
  const [t] = useTranslation();
  const history = useHistory();
  const { search } = useLocation();
  const [status, setStatus] = React.useState<'loading' | 'confirmed' | 'invalid'>('loading');

  React.useEffect(() => {
    const query = new URLSearchParams(search);
    const userId = query.get('userId');
    const code = query.get('code');
    if (!userId || !code) {
      setStatus('invalid');
      return;
    }
    apiSdk.UserService.confirmEmail({ body: { userId, code } })
      .then(res => setStatus(res.success ? 'confirmed' : 'invalid'))
      .catch(() => setStatus('invalid'));
  }, [search]);

  return (
    <div
      className="container-login-form"
      style={{ minHeight: '100vh', backgroundImage: `url(${authBackgroundImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
    >
      <Card className="login-form" bodyStyle={{ padding: 0, border: 'none' }} style={{ border: 'none' }}>
        <div
          style={{
            textAlign: 'center',
            marginBottom: 10,
            paddingTop: 20,
            paddingBottom: 20,
            position: 'relative',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: '#dddddd80',
          }}
        >
          <img src={authLogo} alt="auth-logo" style={{ width: 100 }} />
          <span style={{ color: '#0a8ca3', fontSize: 50, marginLeft: 10, textTransform: 'uppercase', fontWeight: 'bold' }}>{AppName}</span>
          <div className="change-language-container">
            <LanguageSelector />
          </div>
        </div>
        <div style={{ textAlign: 'center', padding: 50 }}>
          <h1>{t('confirmEmailPage_Title')}</h1>
          {status === 'loading' ? (
            <Spin />
          ) : (
            <>
              <div
                data-testid={`confirm-email-${status}`}
                style={{ fontSize: 20, color: status === 'confirmed' ? '#0a8ca3' : '#f44336', marginBottom: 20 }}
              >
                {t(status === 'confirmed' ? 'confirmEmailPage_Success' : 'confirmEmailPage_Invalid')}
              </div>
              <Button icon={<LeftOutlined />} type="ghost" onClick={() => history.push(PublicRoutes.Login)}>
                {t('forgotPasswordPage_BackToLoginPage')}
              </Button>
            </>
          )}
        </div>
      </Card>
    </div>
  );
};
export default ConfirmEmail;
